function n(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
export {
  n as default
};
